import React, { useState, useEffect } from "react";
import axios from "../../axiosInstance"; // Ensure axios is configured correctly
import "./AdsBanner.css";

const AdsBanner = ({ placement, page }) => {
  const [ads, setAds] = useState([]);
  const BASE_URL = process.env.REACT_APP_API_URL || "https://todaylocal.in/api";
  const district = localStorage.getItem("district");

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const response = await axios.get("/api/admin/ads/display", {
          params: { placement, page, district },
        });

        if (response.data?.ads?.length) {
          setAds(response.data.ads);
        } else {
          console.warn("No ads found:", response.data);
          setAds([]); // Reset ads if no data is found
        }
      } catch (error) {
        console.error("Error fetching ads:", error.message);
      }
    };

    fetchAds();
  }, [district, placement, page]);

  return (
    <div className="user-ads-banner">
      <div className="user-ads-container">
        {ads.length > 0 ? (
          ads.map((ad, index) =>
            ad.ads.map((adItem, subIndex) => (
              <a
                href={adItem.url || "#"}
                key={`${index}-${subIndex}`}
                className="user-ad-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={`${BASE_URL}/${adItem.image}`}
                  alt={adItem.alt || `Ad ${index + 1}`}
                  className="user-ad-image"
                />
              </a>
            ))
          )
        ) : (
          <p className="no-ads-message">No ads available</p>
        )}
      </div>
    </div>
  );
};

export default AdsBanner;
